<template>
    <b-button-group>
        <b-form-input ref="discountInput" class="discount-input"
                      :tabindex="parseInt(tabindex)"
                      :autofocus="autofocus"
                      :value="value.value"
                      @input="inputEvent"
                      @change="changeEvent"
                      :key="key"
                      type="number"></b-form-input>
        <b-button variant="light" @click="setSign">
            <div v-if="value.measure === '$'">
                <i class="fe fe-dollar-sign"></i>
            </div>
            <div v-else>
                <i class="fe fe-percent"></i>
            </div>
        </b-button>
    </b-button-group>
</template>

<script>
export default {
    name: "DiscountField",
    props: {
        value: Object,
        static: Boolean,
        tabindex: { type: [String, Number], default: 0 },
        max: { type: Number, default: 100 },
        autofocus: { type: Boolean, default: true }
    },
    data() {
        return {
            key: '1', // this is necessary to rerender the b-form-input
        }
    },

    methods: {
        forceUpdate() {
            this.key = '2'
            this.$nextTick().then(() => {
                this.key = '1'
            })
        },

        setSign() {
            let localCopy = Object.assign({}, this.value)
            localCopy.measure = '$'
            if (this.value.measure === '$')
                localCopy.measure = '%'

            if (localCopy.measure === '%' && localCopy.value > this.max) {
                this.forceUpdate()
                localCopy.value = this.max
                this.$emit('input', localCopy)
                this.$emit('change', localCopy)
                return
            }
            this.$emit('input', localCopy)
            this.$emit('change', localCopy)
        },

        inputEvent(value) {
            let localCopy = Object.assign({}, this.value)
            localCopy.value = value
            if (!localCopy.measure)
                localCopy.measure = '%';

            if (localCopy.measure === '%' && localCopy.value > this.max) {
                this.forceUpdate()
                return
            }
            this.$emit('input', localCopy)
        },

        changeEvent(value) {
            let localCopy = Object.assign({}, this.value)
            localCopy.value = value
            if (!localCopy.measure)
                localCopy.measure = '%';

            if (localCopy.measure === '%' && localCopy.value > this.max) {
                this.forceUpdate()
                return
            }
            this.$emit('change', localCopy)
        }
    },
    computed: {}
}
</script>

<style scoped>
.discount-input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    min-width: 50px;
}

.discount-dropdown .dropdown-menu {
    min-width: 4rem;
}
</style>
